"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'isMobileView'], function (_a, carmiProps) {
    var compData = _a.compData, compProps = _a.compProps, isMobileView = _a.isMobileView;
    var totalPages = compData.totalPages, currentPage = compData.currentPage, nextText = compData.nextText, previousText = compData.previousText, firstText = compData.firstText, lastText = compData.lastText;
    var navigationType = carmiProps.navigationType;
    var showFirstLastNavButtons = compProps.showFirstLastNavButtons, showFirstPage = compProps.showFirstPage, showLastPage = compProps.showLastPage, showInputModeTotalPages = compProps.showInputModeTotalPages, paginationDirection = compProps.paginationDirection, paginationMode = compProps.paginationMode, isDisabled = compProps.isDisabled;
    var paginationProps = {
        totalPages: totalPages,
        currentPage: currentPage,
        nextText: nextText,
        previousText: previousText,
        firstText: firstText,
        lastText: lastText,
        showFirstLastNavButtons: showFirstLastNavButtons,
        navigationType: navigationType,
        paginationDirection: paginationDirection,
        isDisabled: isDisabled,
    };
    var propsMapper = {
        input: __assign(__assign({}, paginationProps), { showTotalPages: showInputModeTotalPages }),
        pages: __assign(__assign({}, paginationProps), { showFirstLastPageButtons: showFirstPage || showLastPage, isResponsiveHeight: isMobileView }),
    };
    return propsMapper[paginationMode];
});
//# sourceMappingURL=Pagination.js.map